import { useCallback, useEffect, useMemo } from "react";
import throttle from "lodash/throttle";
import { TYPING_SEND_INTERVAL_MILLISECONDS } from "modules/utils/Constants";
import { useMutation } from "@apollo/client";
import { TypingMutation, TypingMutationVariables } from "gql/graphql";
import TYPING_MUTATION from "../messaging/_networking/typing";

interface IProps {
  messageThreadId: string;
}

const useUserTyping = ({ messageThreadId }: IProps) => {
  const [typingMutationAPI] = useMutation<
    TypingMutation,
    TypingMutationVariables
  >(TYPING_MUTATION);

  const throttledSend = useMemo(
    () =>
      throttle(
        () =>
          typingMutationAPI({
            variables: { messageThreadId },
          }),
        TYPING_SEND_INTERVAL_MILLISECONDS,
        { leading: true, trailing: false },
      ),
    [messageThreadId, typingMutationAPI],
  );

  useEffect(() => () => throttledSend.cancel(), [throttledSend]);

  const onTyping = useCallback(
    (lastChar: string) => {
      if (lastChar.length === 1) {
        throttledSend();
      }
    },
    [throttledSend],
  );

  return onTyping;
};

export default useUserTyping;
